"use strict";

require("core-js/modules/es6.array.find");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
function openModal(modal) {
  modal.modal('show');
}
exports.openModal = openModal;
function hideModal(modal) {
  modal.modal('hide');
}
exports.hideModal = hideModal;
function cleanModalData(modal) {
  var $this = modal;
  if (modal.find('.sending-result').children().length > 0) {
    $this.find('input').val('');
    $this.find('.sending-result').empty();
    $this.find(':checkbox').prop("checked", false);
    $this.find('button').prop('disabled', false);
    if ($this.find('#g-recaptcha').length) {
      grecaptcha.reset();
    }
  }
  if (modal.find('#submit_newsletter')) {
    $('#submit_close').hide();
    $('#submit_newsletter').show();
  }
}
exports.cleanModalData = cleanModalData;
function getOuterHeightofElement(element) {
  if ($(element).length > 0) {
    return $(element).outerHeight(true);
  } else {
    return 0;
  }
}
exports.getOuterHeightofElement = getOuterHeightofElement;
function getInnerHeight(element) {
  return $(element).height();
}
exports.getInnerHeight = getInnerHeight;
function clearInlineStyling(element) {
  $(element).attr('style', '');
}
exports.clearInlineStyling = clearInlineStyling;
function showSlideDown(element) {
  $(element).slideDown('slow');
}
exports.showSlideDown = showSlideDown;
function hideSlideUp(element) {
  $(element).slideUp('slow');
}
exports.hideSlideUp = hideSlideUp;
function displayValue(target, value) {
  return $(target).text(value);
}
exports.displayValue = displayValue;
function filterBlurOnPageHandler(el, check) {
  check == true ? $(el).addClass('filter-blur') : $(el).removeClass('filter-blur');
}
exports.filterBlurOnPageHandler = filterBlurOnPageHandler;
function getDataParameter(element, dataMarker) {
  var datas = {
    data_name: dataMarker,
    value: $(element).data(dataMarker)
  };
  return datas;
}
exports.getDataParameter = getDataParameter;
function setDataParameter(element, value, attribute) {
  $(element).attr(attribute, value);
}
exports.setDataParameter = setDataParameter;
function setTagFullParameters(element, newTag, classes, hrefLink) {
  $(element).replaceWith(function () {
    return $("<a />", {
      html: newTag,
      class: classes,
      href: hrefLink
    });
  });
}
exports.setTagFullParameters = setTagFullParameters;